module.exports = __webpack_public_path__ + "img/bancom.d74ec952.svg";